import { useState } from "react";

export default function FortuneResult({ prediction, isLoading, language = "en" }) {
  const [activeTab, setActiveTab] = useState("overall");

  if (isLoading) {
    return (
      <div className="result-box">
        <p>🔮 The crystal ball is thinking...</p>
        <div className="loading-spinner">✨</div>
      </div>
    );
  }

  // Parse prediction into sections
  const parseSections = (text) => {
    const sections = {
      overall: "",
      family: "",
      wealth: "",
      love: "",
      notes: ""
    };

    if (!text) return sections;

    // Define section markers in both languages
    const markers = {
      overall: language === "zh" 
        ? ["整体命运", "总体命运", "综合命运", "Overall Destiny"]
        : ["Overall Destiny", "General Fortune", "整体命运"],
      family: language === "zh"
        ? ["家庭关系", "亲属关系", "家人关系", "Family Relationships"]
        : ["Family Relationships", "Family Relations", "家庭关系"],
      wealth: language === "zh"
        ? ["财富运势", "财运", "事业财富", "Wealth Fortune"]
        : ["Wealth Fortune", "Career and Wealth", "财富运势"],
      love: language === "zh"
        ? ["爱情婚姻", "感情婚姻", "婚恋", "Love and Marriage"]
        : ["Love and Marriage", "Romance and Marriage", "爱情婚姻"],
      notes: language === "zh"
        ? ["重要提示", "注意事项", "特别提醒", "Important Notes"]
        : ["Important Notes", "Key Points", "重要提示"]
    };

    // Split text by sections
    let currentSection = "overall";
    const lines = text.split('\n');
    
    lines.forEach(line => {
      const trimmedLine = line.trim();
      
      // Check which section this line belongs to
      let foundSection = null;
      for (const [key, keywords] of Object.entries(markers)) {
        if (keywords.some(keyword => trimmedLine.includes(keyword))) {
          foundSection = key;
          break;
        }
      }
      
      if (foundSection) {
        currentSection = foundSection;
        // Add the section header
        sections[currentSection] += line + '\n';
      } else if (trimmedLine) {
        sections[currentSection] += line + '\n';
      }
    });

    return sections;
  };

  const sections = parseSections(prediction);

  const tabs = [
    { id: "overall", label: language === "zh" ? "整体命运" : "Overall Destiny", icon: "🌟" },
    { id: "family", label: language === "zh" ? "家庭关系" : "Family", icon: "👨‍👩‍👧" },
    { id: "wealth", label: language === "zh" ? "财富运势" : "Wealth", icon: "💰" },
    { id: "love", label: language === "zh" ? "爱情婚姻" : "Love", icon: "❤️" },
    { id: "notes", label: language === "zh" ? "重要提示" : "Notes", icon: "📝" }
  ];

  const title = prediction 
    ? (language === "zh" ? "命理分析" : "Fortune Analysis")
    : (language === "zh" ? "命运在等待！" : "Destiny Awaits!");

  return (
    <div className="fortune-container">
      <h3 className="fortune-title">
        {title}
      </h3>

      {prediction ? (
        <>
          {/* Tab Navigation */}
          <div className="fortune-tabs">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`fortune-tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              >
                <span style={{ marginRight: "8px", fontSize: "1.2rem" }}>{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="fortune-content">
            {sections[activeTab] || (
              <div style={{ textAlign: "center", color: "#999", paddingTop: "80px", fontSize: "1.1rem" }}>
                {language === "zh" ? "此部分暂无内容" : "No content available for this section"}
              </div>
            )}
          </div>
        </>
      ) : (
        <p style={{ textAlign: "center", color: "#666", fontSize: "1.2rem", paddingTop: "40px" }}>
          {language === "zh" ? "请先输入您的生辰信息" : "Please enter your birth information first"}
        </p>
      )}
    </div>
  );
}